import { AppointmentPolicy } from '@web-app/hooks/queries/appointment-by-room-name/types';
import { defaultPayerActionRules } from '@web-app/utils/payerActions/defaultRules';
import {
  CallPhase,
  PayerAction,
  PayerActionRule,
} from '@web-app/utils/payerActions/types';

class PayerActionEngine {
  private rules: PayerActionRule[] = [];

  constructor() {
    defaultPayerActionRules.forEach((rule) => this.registerRule(rule));
  }

  registerRule(rule: PayerActionRule): void {
    this.rules.push(rule);
  }

  getActionsForPhase(
    phase: CallPhase,
    policies: AppointmentPolicy[],
  ): PayerAction[] {
    const policyPayerIds = policies.map((p) => p.insurance_plan?.payer_id);

    const matchingRules = this.rules.filter((rule) => {
      if (rule.phase !== phase) return false;

      return rule.payerIds.some((payerId) => policyPayerIds.includes(payerId));
    });

    return matchingRules.flatMap((rule) => rule.actions);
  }
}

export const payerActionEngine = new PayerActionEngine();
